import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { PopoverController, ModalController, LoadingController } from '@ionic/angular/lazy';
import { QuoteService } from 'src/app/services/quote.service';
import { PermissionService } from 'src/app/services/permission.service';

@Component({
    selector: 'app-quote-options',
    templateUrl: './quote-options.component.html',
    styleUrls: ['./quote-options.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class QuoteOptionsComponent implements OnInit {

    @Input() quote_page = null;
    quote = null;
    @Input() printer_paper_sizes = [];
    spinner = null;

    constructor(
        private popoverCtrl: PopoverController,
        public modalController: ModalController,
        private quoteService: QuoteService,
        public loadingController: LoadingController,
        public permissionService: PermissionService
    ) { }

    ngOnInit() {
        this.quote_page = this.quote_page
        this.quote = this.quote_page.quote
    }

    async dismiss() {
        try {
            await this.popoverCtrl.dismiss();
        } catch (e) {
            // click more than one time popover throws error, so ignore...
        }
    }

    presentQuoteMarkAsSentModal() {
        this.quote_page.presentQuoteMarkAsSentModal();
        this.dismiss();
    }

    presentQuoteMarkAsDeclinedModal() {
        this.quote_page.presentQuoteMarkAsDeclinedModal();
        this.dismiss();
    }

    presentQuoteMarkAsAcceptedModal() {
        this.quote_page.presentQuoteMarkAsAcceptedModal();
        this.dismiss();
    }

    presentQuoteCancelModal() {
        this.quote_page.presentQuoteCancelModal();
        this.dismiss();
    }

    presentQuoteEditModal() {
        this.quote_page.presentQuoteEditModal();
        this.dismiss();
    }

    public deleteQuote() {
        this.quote_page.deleteQuote();
        this.dismiss();
    }

    public openQuote() {
        this.quote_page.openQuote();
        this.dismiss();
    }

    public duplicateQuote() {
        this.quote_page.duplicateQuote();
        this.dismiss();
    }

    public archiveQuote() {
        this.presentSpinner("Archiving quote").then(() => {
            this.quoteService.updateQuote(this.quote.id, {archived: true}).then(() => {
                this.spinner.dismiss();
                this.dismiss();
            })
            .catch(() => {
                this.spinner.dismiss();
                this.dismiss();
            });
        });
    }

    public unarchiveQuote() {
        this.presentSpinner("Unarchiving quote").then(() => {
            this.quoteService.updateQuote(this.quote.id, {archived: false}).then(() => {
                this.spinner.dismiss();
                this.dismiss();
            })
            .catch(() => {
                this.spinner.dismiss();
                this.dismiss();
            });
        });
    }

    public presentQuoteEmailModal() {
        this.quote_page.presentQuoteEmailModal();
        this.dismiss();
    }

    public printQuote(paper_size) {
        this.quote_page.printQuote(paper_size);
        this.dismiss();
    }

    async presentSpinner(message) {
        this.spinner = await this.loadingController.create({
            message: message,
            showBackdrop: false,
        });
        await this.spinner.present();
    }

}
